<template>
    <section>

        <div class="row">
            <div class="col-md-3 col-sm-12 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>  
            <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm seminar-right-colm">
                <div class="right-content bg-white">
                    <div class="col-sm-12 col-md-12">
                        <div class="content-colm">
                            <h4 v-html="webContent.PreLoginSeminarsText5"></h4>
                        </div>
                        <div class="box-detail">
                            <p>
                                <br />
                                <span v-for="(mod, indx) in nextModule" :key="indx">
                                    <template v-if="indx == 0">
                                        {{ mod.ModuleVenue }} <br>
                                        {{ mod.ModuleAddress1 }}<br>
                                        <span v-if="mod.ModuleAddress2 != ''">{{ mod.ModuleAddress2 }}</span>
                                        {{ mod.ModuleCity }}, {{ mod.ModuleState }} {{ mod.ModuleZip }}
                                    </template>
                                </span>

                            </p>
                            <h3 v-html="webContent.PreLoginSeminarsText6"></h3>

                        </div>

                        <hr>
                        <h5>The upcoming Seminar schedule: </h5>
                        <div class="material-list">
                            <ul>
                                <!-- <li v-for="(next, ind) in nextModule" :key="ind"><i class="fa fa-arrow-right"
                                        aria-hidden="true"></i> Module {{ next.ModuleNumber }}:
                                    {{ next.ModuleName }} - {{ moduleDate(next.ModuleStartDate, next.SeminarStartTime) }}
                                </li> -->
                                <li v-for="(next, ind) in nextModule" :key="ind">Module {{ next.ModuleNumber }}:
                                    {{ next.ModuleName }} - {{ moduleDate(next.ModuleStartDate, next.SeminarStartTime) }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="material-box bg-white mt-1 seminar-bottom">
                    <div class="row content-row">
                        <div class="col-md-12 top-title">
                            <h3>Seminar Archives</h3>
                            <p>DC Trainings provides you with a complete archive of videos, from past Seminars.<br>
                                These videos are broken up into the Weekly segments of the Seminar.</p>
                        </div>
                        <div class="content-colm col-md-12">
                            <div class=" row">
                                <div class="skill-btn archieve-btn" v-for="(archive, index) in archiveModules"
                                    :key="index">
                                    <router-link :to="{ name: 'SeminarArchive', params: { id: archive.ModuleID } }"
                                        class="m-b-5 btn-fixwidth">Module {{ archive.ModuleNumber }} - {{ archiveYear(
                                            archive.ModuleStartDate) }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end content-row ---->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import moment from 'moment';

export default {
    name: "Seminar",
    data() {
        return {
            isLoading: false,
            webContent: [],
            nextModule: [],
            archiveModules: {},

        }
    },
    methods: {
        archiveYear(date) {
            if (moment().format('MM-DD-Y') > moment(date).format('MM-DD-Y')) {
                return moment(date).format('Y');
            }
            return moment(date).format('Y')  ;
        },
        moduleDate(module, seminar) {
            if (module != null || module != '') {
                return moment(module).format('MMMM DD, Y');
            }
            return moment(seminar).format('MMMM DD, Y')
        },
        getArchivesModules() {
            userAPI.getAllModules(res => {
                this.archiveModules = res.data.data;

            }, err => {
                console.log(err);
            })
        },
        getNextModule() {
            userAPI.getNextModule(res => {
                this.nextModule = res.data.data;
            })
        },
        getWebContent() {
            this.isLoading = true;
            userAPI.getWebContent(res => {
                this.webContent = res.data;
                this.isLoading = false;
            }, err => {
                console.log(err);
                this.isLoading = false;
            })
        }
    },
    mounted() {
        this.getWebContent()
        this.getNextModule()
        this.getArchivesModules()
    },
    components: {
        Sidebar
    }
}
</script>